/// <amd-module name="Wit/Common/KanbanBoardSettings/Components/TestSettingsView/SelectTestPlanPanel" />
import * as React from "react";
import { ScreenSize } from "VSS/Core/Util/Screen";
import { ContentSize } from "VSSUI/Callout";
import { IPanelProps, Panel } from "VSSUI/Panel";
import { ScreenSizeObserver } from "VSSUI/Utilities/ScreenSize";
import { WorkItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import * as Resources from "Wit/Common/KanbanBoardSettings/Resources";
import { SelectTestItemForm } from "Wit/Common/WorkItemDialogs/Components/SelectTestItemForm";

interface ISelectTestPlanPanelProps extends Pick<IPanelProps, "onDismiss"> {
    onTestPlanSelected(plan: WorkItem): void;
}

export const SelectTestPlanPanel: React.FunctionComponent<ISelectTestPlanPanelProps> = ({ onDismiss, onTestPlanSelected }) => {
    const [selectedPlan, setSelectedPlan] = React.useState<WorkItem | undefined>(undefined);

    const onClickSelectPlan = () => {
        selectedPlan && onTestPlanSelected(selectedPlan);
        onDismiss();
    };

    const onSelectionChanged = (workItem: WorkItem) => {
        setSelectedPlan(workItem);
    };

    return (
        <ScreenSizeObserver>
            {({ screenSize }: { screenSize: ScreenSize }) => (
                <Panel
                    footerButtonProps={[
                        { onClick: onDismiss, text: Resources.Cancel },
                        { disabled: !selectedPlan, onClick: onClickSelectPlan, primary: true, text: Resources.SelectPlanButton }
                    ]}
                    onDismiss={onDismiss}
                    size={screenSize <= Number(ScreenSize.small) ? ContentSize.Large : ContentSize.ExtraLarge}
                    titleProps={{ text: Resources.SelectTestPlan }}
                >
                    <SelectTestItemForm testItemType="Microsoft.TestPlanCategory" onSelectionChanged={onSelectionChanged} />
                </Panel>
            )}
        </ScreenSizeObserver>
    );
};
